var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 280,
    viewBox: "0 0 86 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4639_123185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5575 257.66C42.3475 257.66 42.1875 257.49 42.1875 257.28V0.38C42.1875 0.17 42.3575 0 42.5575 0C42.7575 0 42.9275 0.17 42.9275 0.38V257.28C42.9275 257.49 42.7575 257.66 42.5575 257.66Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2306 275.18C51.2306 277.81 47.3506 279.95 42.5606 279.95C37.7706 279.95 33.8906 277.81 33.8906 275.18C33.8906 272.55 37.7706 270.41 42.5606 270.41C47.3506 270.41 51.2306 272.55 51.2306 275.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.81 264.54C51.35 260.46 45.43 257.36 42.55 252.8C39.68 257.36 33.75 260.46 18.29 264.54C2.28 268.77 0.04 275.15 0 275.18H42.56H85.12C85.08 275.16 82.84 268.78 66.82 264.55L66.81 264.54Z",
    fill: "#F09400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4639_123185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.11,
    height: 279.95,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.a016a5c978fef525995d504561a742b8.svg";
export { ForwardRef as ReactComponent };